import { ContentTypeFilter } from './content-type.filter';

export { ContentTypeFilter };
